const universityLibrariesConfig = {
  iconPath: '/img/logos/',
  contacts: [
    {
      id: 'mainCampus',
      title: 'University Libraries',
      subtitle: 'Main Campus',
      link: 'http://www.odu.edu/library',
      phone: '757-683-4179',
      phoneLink: 'tel:757-683-4179',
      ariaLabel: 'Call University Library at 757-683-4179',
    },
    {
      id: 'evms',
      title: 'Brickell Medical Sciences Library',
      subtitle: 'Virginia Health Sciences',
      link: 'https://www.evms.edu/library',
      phone: '757-446-5851',
      phoneLink: 'tel:757-446-5851',
      ariaLabel: 'Call Brickell Medical Sciences Library at 757-446-5851',
    },
  ],
  locations: [
    {
      title: 'ODU Library Resources',
      isExpand: false,
      apps: [
        {
          id: 'universityLibraries_odu_monarchOneSearch',
          name: 'Monarch OneSearch',
          icon: 'monarchOneSearch.svg',
          link: 'https://odu-primo.hosted.exlibrisgroup.com/primo-explore/search?vid=01ODU_NUI&amp;lang=en_US',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_odu_roomReservations',
          name: 'Room Reservations',
          icon: 'roomReservations.svg',
          link: 'https://www.odu.edu/library/places-spaces/room-reservations',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_odu_libraryGuides',
          name: 'Library Guides',
          icon: 'libraryGuides.svg',
          link: 'https://guides.lib.odu.edu/',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_odu_researchHelp',
          name: 'Research Help',
          icon: 'researchHelp.svg',
          link: 'https://www.odu.edu/library/help',
          linkTarget: '_blank',
        },
      ],
      libraryLinks: [
        {
          id: 'universityLibraries_odu_databases',
          title: 'Databases',
          link: 'https://guides.lib.odu.edu/az.php',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_odu_calendar',
          title: 'Calendar',
          link: 'https://www.odu.edu/library/about/news-events-exhibits/calendar',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_odu_hours',
          title: 'Hours',
          link: 'https://odu.libcal.com/hours/',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_odu_interlibraryLoan',
          title: 'Interlibrary Loan',
          link: 'https://ww1.odu.edu/library/services/interlibrary-loan',
          linkTarget: '_blank',
        },
      ],
    },
    {
      title: 'Health Sciences Resources at Brickell Library',
      isExpand: true,
      apps: [
        {
          id: 'universityLibraries_evms_worldCat',
          name: 'Worldcat Discovery Search',
          icon: 'worldcat.svg',
          link: 'https://evms.on.worldcat.org/discovery',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_evms_pubmed',
          name: 'PubMed Search',
          icon: 'pubmed.svg',
          link: 'https://www.ncbi.nlm.nih.gov/pubmed?otool=vaeebmlib&holding=vaeebmlib',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_evms_askALibrarian',
          name: 'Ask a Librarian',
          icon: 'askALibrarian.svg',
          link: 'https://www.evms.edu/library/services/reference/',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_evms_quicklinks',
          name: 'Quick Links',
          icon: 'quicklinks.svg',
          link: ' https://www.evms.edu/library/quicklinks/',
          linkTarget: '_blank',
        },
      ],
      libraryLinks: [
        {
          id: 'universityLibraries_evms_databases',
          title: 'Databases',
          link: 'https://evms.libguides.com/az.php',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_evms_researchGuides',
          title: 'Research Guides',
          link: 'https://evms.libguides.com/',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_evms_documentDelivery',
          title: 'Document Delivery/ILL',
          link: 'https://www.evms.edu/library/services/circ/ill/',
          linkTarget: '_blank',
        },
        {
          id: 'universityLibraries_evms_services',
          title: 'Services',
          link: 'https://www.evms.edu/library/services',
          linkTarget: '_blank',
        },
      ],
    },
  ],
};

export default universityLibrariesConfig;
